/**
 * 日期 / 时间 / 文案格式化工具。
 * 所有日期按 Asia/Shanghai 输出；竞彩营业日（businessDate）与自然日不同：
 * 凌晨场次归入前一天批次。
 */
export const SHANGHAI = 'Asia/Shanghai';

export function shanghaiDate(offset = 0): string {
  const date = new Date(Date.now() + offset * 86400000);
  return new Intl.DateTimeFormat('en-CA', { timeZone: SHANGHAI }).format(date);
}

/** 竞彩营业日：11:00 前算前一天批次（与足彩计算器口径一致）。 */
export function businessDateToday(offset = 0): string {
  const now = Date.now() + offset * 86400000;
  const shanghaiHour = new Date(now + 8 * 3600 * 1000).getUTCHours();
  const shift = shanghaiHour < 11 ? -1 : 0;
  return new Intl.DateTimeFormat('en-CA', { timeZone: SHANGHAI }).format(new Date(now + shift * 86400000));
}

export function shiftDate(value: string, offset: number): string {
  const date = new Date(value + 'T12:00:00+08:00');
  date.setUTCDate(date.getUTCDate() + offset);
  return new Intl.DateTimeFormat('en-CA', { timeZone: SHANGHAI }).format(date);
}

/** 周X MM-DD HH:mm；比赛时间必须带真实比赛日期（凌晨场次显示真实日期）。 */
export function formatKickoff(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const weekday = new Intl.DateTimeFormat('zh-CN', { timeZone: SHANGHAI, weekday: 'short' }).format(date);
  const stamp = new Intl.DateTimeFormat('en-CA', { timeZone: SHANGHAI, month: '2-digit', day: '2-digit' }).format(date).replace('/', '-');
  const time = new Intl.DateTimeFormat('zh-CN', { timeZone: SHANGHAI, hour: '2-digit', minute: '2-digit', hour12: false }).format(date);
  return weekday + ' ' + stamp + ' ' + time;
}

export function formatTime(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat('zh-CN', { timeZone: SHANGHAI, hour: '2-digit', minute: '2-digit', hour12: false }).format(date);
}

const WEEKDAYS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
export function batchLabel(date: string): string {
  const parsed = new Date(date + 'T12:00:00+08:00');
  return Number.isNaN(parsed.getTime()) ? '' : WEEKDAYS[parsed.getDay()] ?? '';
}

export function oddsText(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : value.toFixed(2);
}

export function percent(value: number): string {
  return Math.round(value * 100) + '%';
}

/** 比赛状态文案（进行中带即时分钟）。 */
export function statusLabel(match: { status: string; live?: { phase?: string | null; minute?: number | null } | null }): string {
  if (match.status === 'finished') return '完场';
  if (match.status === 'live') return (match.live?.phase ?? '进行中') + (match.live?.minute ? ' ' + match.live.minute + "'" : '');
  if (match.status === 'scheduled') return '未开赛';
  return match.live?.phase ?? match.status;
}

export const DATA_NOTE_LABELS: Record<string, string> = {
  match_not_in_lottery: '未开售竞彩',
  history_not_fetched: '竞彩赔率待抓取',
  awaiting_fixed_bonus: '全玩法赔率抓取中',
  market_not_offered: '源站未提供该玩法',
  partial_markets: '部分玩法未开售',
  no_matches_for_date: '该日无竞彩场次',
  cancelled: '该场竞彩已取消',
  no_odds_history: '源站无赔率记录',
  source_error: '抓取失败，可重试',
  outside_199d_window: '超出竞彩可回溯窗口',
  non_core_league: '非核心联赛，未采集威廉/立博',
};

export function dataNoteLabel(note: string | null | undefined): string | null {
  if (!note) return null;
  return DATA_NOTE_LABELS[note] ?? note;
}
